export default __webpack_public_path__ + "7f563574e3a83a779ab723c08669c054.svg";